import $ from 'jquery';
import _ from 'lodash';
import Highcharts from 'highcharts';
import message from '../../../../../utils/message';

/*

 【試験スコア記録帳 スコア分布】
 00: ユーザーID
 01: 名前
 02: 名前（英語）
 03: 学年
 04: 組
 05: 出席番号
 06: 性別
 07: ログイン回数
 08: 最終ログイン日時
 09: 学年
 10: 番号
 11: スコア
 12: 偏差値

 */

function buildChart($csv_chart_area, csv_download_url, papa_data) {
  const categories = [
    0,
    5,
    10,
    15,
    20,
    25,
    30,
    35,
    40,
    45,
    50,
    55,
    60,
    65,
    70,
    75,
    80,
    85,
    90,
    95,
    100,
  ];
  const bunpu_data = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
  ];
  // ヘッダーを削除
  papa_data.data.shift();
  console.log('-------');
  console.log(bunpu_data);
  const yukou_scores = [];
  _.each(papa_data.data, (o) => {
    if (o[11] !== '') {
      const score = Number(o[11]);
      yukou_scores.push(score);
      if (score === 0) {
        bunpu_data[0] += 1;
      } else if (score <= 5) {
        bunpu_data[1] += 1;
      } else if (score <= 10) {
        bunpu_data[2] += 1;
      } else if (score <= 15) {
        bunpu_data[3] += 1;
      } else if (score <= 20) {
        bunpu_data[4] += 1;
      } else if (score <= 25) {
        bunpu_data[5] += 1;
      } else if (score <= 30) {
        bunpu_data[6] += 1;
      } else if (score <= 35) {
        bunpu_data[7] += 1;
      } else if (score <= 40) {
        bunpu_data[8] += 1;
      } else if (score <= 45) {
        bunpu_data[9] += 1;
      } else if (score <= 50) {
        bunpu_data[10] += 1;
      } else if (score <= 55) {
        bunpu_data[11] += 1;
      } else if (score <= 60) {
        bunpu_data[12] += 1;
      } else if (score <= 65) {
        bunpu_data[13] += 1;
      } else if (score <= 70) {
        bunpu_data[14] += 1;
      } else if (score <= 75) {
        bunpu_data[15] += 1;
      } else if (score <= 80) {
        bunpu_data[16] += 1;
      } else if (score <= 85) {
        bunpu_data[17] += 1;
      } else if (score <= 90) {
        bunpu_data[18] += 1;
      } else if (score <= 95) {
        bunpu_data[19] += 1;
      } else if (score <= 100) {
        bunpu_data[20] += 1;
      } else {
        // 通常ここに来ない
        console.error(score);
      }
    }
  });
  console.log('-------');
  console.log(papa_data.data);
  let avg = _.reduce(yukou_scores, (memo, num) => memo + num, 0) / yukou_scores.length;
  avg = avg.toFixed(1);
  let plotLines = [];
  if (avg >= 0) {
    plotLines = [{
      // TODO この値がよくわからない設定方法を調べる事
      value: Math.floor(avg / 5),
      zIndex: 10,
      color: '#000000',
      width: 1,
      label: {
        text: `クラス平均(${avg})`,
      },
    }];
  }
  $csv_chart_area.highcharts({
    chart: {
      type: 'column',
    },

    legend: {
      enabled: false,
    },
    title: {
      text: message.scoreDistribution,
    },

    xAxis: {
      categories,
      endOnTick: true,
      plotLines,
    },
    yAxis: {
      min: 0,
      title: {
        text: message.numOfStudents,
      },
    },
    tooltip: {

      headerFormat: '',
      pointFormatter() {
        if (this.category === 100) {
          return `<span style="color:${this.color}">${this.category}点</span><br /><b>${this.y}</b>人<br/>`;
        }

        return `<span style="color:${this.color}">${this.category}-${(this.category + 4)}点</span><br /><b>${this.y}</b>人<br/>`;
      },

      shared: true,
      useHTML: true,
    },

    plotOptions: {
      // バーの隅間を空けない設定 0 for tightly packed columns,
      series: {
        pointPadding: 0,
        groupPadding: 0,
        borderWidth: 0,
        shadow: false,
      },
    },

    series: [{
      name: 'Score',
      data: bunpu_data,
    }],
  });
}

export default buildChart;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/classportfolio/external_exam.js